/**
 * hogar.ts — Categoría "Hogar / Menaje" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_hogar",
  skuPrefix: "HOG",
  categoria: "Hogar / Menaje",
} as const;

export const cat_hogar_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Juego Sábanas Queen",
    marca: "Sybaris",
    modelo: "Percal 300 hilos",
    origen: "Colombia",
    costo: 145000,
    precio: 229000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "set",
    ubicacionFisica: "Estante H1",
    proveedor: "Sybaris Home",
    material: "100% algodón percal",
    colorProducto: "Gris perla",
    dimensiones: "Queen",
    descripcionLarga:
      "Set 4 piezas (sábana base, encimera y 2 fundas almohada) en percal 300 hilos. Suave y transpirable.",
    especificaciones: [
      { clave: "Hilos", valor: "300" },
      { clave: "Tamaño", valor: "Queen" },
    ],
    imageKeywords: ["bed-sheets", "bedding", "cotton-sheets"],
    color: "bg-slate-400",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Juego Vajilla 16pzs",
    marca: "Corelle",
    modelo: "Winter Frost",
    origen: "EE.UU.",
    costo: 185000,
    precio: 289000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "set",
    ubicacionFisica: "Estante H2",
    proveedor: "Corelle Colombia",
    garantia: "3 años",
    material: "Vitroporcelana",
    colorProducto: "Blanco",
    descripcionLarga:
      "Vajilla 16 piezas (4 platos hondos, 4 playos, 4 postre, 4 tazas). Resistente a impactos y apta lavavajillas/microondas.",
    especificaciones: [
      { clave: "Piezas", valor: "16" },
      { clave: "Lavavajillas", valor: "Apto" },
    ],
    imageKeywords: ["dinnerware", "dishes-set", "kitchen-plates"],
    color: "bg-white",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Olla Presión 6L",
    marca: "Imusa",
    modelo: "Classic 6L",
    origen: "Colombia",
    costo: 125000,
    precio: 195000,
    stock: 22,
    stockMinimo: 6,
    stockMaximo: 44,
    unidad: "unidad",
    ubicacionFisica: "Estante H3",
    proveedor: "Imusa S.A.",
    garantia: "3 años",
    material: "Aluminio",
    dimensiones: "6L capacidad",
    descripcionLarga:
      "Olla a presión Imusa 6L con triple sistema de seguridad. Reduce 70% tiempo de cocción y consume menos gas.",
    especificaciones: [
      { clave: "Capacidad", valor: "6L" },
      { clave: "Seguridad", valor: "Triple" },
    ],
    imageKeywords: ["pressure-cooker", "kitchen-pot", "imusa"],
    color: "bg-slate-300",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Sartén Antiadherente 28cm",
    marca: "Tramontina",
    modelo: "Starflon Max",
    origen: "Brasil",
    costo: 85000,
    precio: 129000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante H3",
    proveedor: "Tramontina Colombia",
    garantia: "2 años",
    material: "Aluminio + Starflon Max",
    dimensiones: "28cm",
    descripcionLarga:
      "Sartén 28cm con triple capa antiadherente Starflon Max. Compatible inducción, gas y eléctrica. Libre de PFOA.",
    especificaciones: [
      { clave: "Diámetro", valor: "28cm" },
      { clave: "Inducción", valor: "Sí" },
    ],
    imageKeywords: ["frying-pan", "nonstick-pan", "tramontina"],
    color: "bg-slate-900",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Juego Cubiertos 24pzs",
    marca: "Tramontina",
    modelo: "Amazonas",
    origen: "Brasil",
    costo: 95000,
    precio: 149000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "set",
    ubicacionFisica: "Estante H2",
    proveedor: "Tramontina Colombia",
    material: "Acero inoxidable 18/10",
    descripcionLarga:
      "Juego cubiertos 24 piezas (6 tenedores, cuchillos, cucharas y cucharitas) en acero inoxidable 18/10. Para 6 personas.",
    especificaciones: [
      { clave: "Piezas", valor: "24" },
      { clave: "Material", valor: "Acero 18/10" },
    ],
    imageKeywords: ["cutlery", "silverware", "flatware"],
    color: "bg-slate-300",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Cortina Blackout 1.4x2.3m",
    marca: "Ikea",
    modelo: "Blackout Basic",
    origen: "Suecia",
    costo: 95000,
    precio: 149000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante H4",
    proveedor: "Ikea Colombia",
    material: "100% poliéster",
    colorProducto: "Gris oscuro",
    dimensiones: "1.4x2.3m",
    descripcionLarga:
      "Cortina opacidad 100% blackout, bloquea luz y reduce ruido. Ojales metálicos superiores. Lavable a máquina.",
    especificaciones: [
      { clave: "Opacidad", valor: "100%" },
      { clave: "Tamaño", valor: "1.4x2.3m" },
    ],
    imageKeywords: ["blackout-curtains", "curtains", "window-curtain"],
    color: "bg-slate-700",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Juego Toallas 6 piezas",
    marca: "Coquí",
    modelo: "Egipcia 600gr",
    origen: "Colombia",
    costo: 125000,
    precio: 189000,
    stock: 22,
    stockMinimo: 6,
    stockMaximo: 44,
    unidad: "set",
    ubicacionFisica: "Estante H1",
    proveedor: "Textiles Coquí",
    material: "100% algodón egipcio",
    colorProducto: "Beige",
    descripcionLarga:
      "Set 6 toallas (2 baño, 2 manos, 2 cara) algodón egipcio 600gr/m². Alta absorción y suavidad duradera.",
    especificaciones: [
      { clave: "Gramaje", valor: "600gr/m²" },
      { clave: "Piezas", valor: "6" },
    ],
    imageKeywords: ["bath-towels", "towel-set", "egyptian-cotton"],
    color: "bg-amber-200",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Organizador Clóset 6 Cubos",
    marca: "Rubbermaid",
    origen: "EE.UU.",
    costo: 125000,
    precio: 189000,
    stock: 18,
    stockMinimo: 5,
    stockMaximo: 36,
    unidad: "unidad",
    ubicacionFisica: "Estante H5",
    proveedor: "Rubbermaid Colombia",
    material: "PP y tela no tejida",
    colorProducto: "Gris",
    dimensiones: "90x30x90cm",
    descripcionLarga:
      "Organizador tipo estantería con 6 cubos de tela y estructura metálica. Ideal closet, zapatos, juguetes.",
    especificaciones: [
      { clave: "Cubos", valor: "6" },
      { clave: "Carga/estante", valor: "15kg" },
    ],
    imageKeywords: ["closet-organizer", "storage-shelf", "cube-storage"],
    color: "bg-slate-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Juego Ollas 5pzs",
    marca: "Imusa",
    modelo: "Eterna Granite",
    origen: "Colombia",
    costo: 285000,
    precio: 439000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "set",
    ubicacionFisica: "Estante H3",
    proveedor: "Imusa S.A.",
    garantia: "3 años",
    material: "Aluminio + antiadherente granite",
    descripcionLarga:
      "Set 5 ollas (olla 1.5L, 2.5L, 4L, sartén 24cm + tapa) con antiadherente granito. Inducción compatible.",
    especificaciones: [
      { clave: "Piezas", valor: "5" },
      { clave: "Inducción", valor: "Sí" },
    ],
    imageKeywords: ["cookware-set", "pots-pans", "kitchen-set"],
    color: "bg-slate-700",
    shape: "circle",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Almohada Memory Foam",
    marca: "Rose Comfort",
    origen: "Colombia",
    costo: 85000,
    precio: 129000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "unidad",
    ubicacionFisica: "Estante H1",
    proveedor: "Rose Comfort S.A.S.",
    material: "Memory foam + funda bambú",
    dimensiones: "60x40x12cm",
    descripcionLarga:
      "Almohada ergonómica memory foam con funda extraíble de bambú. Soporte cervical, reduce dolores al dormir.",
    especificaciones: [
      { clave: "Relleno", valor: "Memory foam" },
      { clave: "Funda", valor: "Bambú lavable" },
    ],
    imageKeywords: [
      "memory-foam-pillow",
      "orthopedic-pillow",
      "bedding-pillow",
    ],
    color: "bg-white",
    shape: "square",
  }),
];
